module.exports = __webpack_public_path__ + "Roboto-Thin.94998475f6aea65f5584.ttf";


//////////////////
// WEBPACK FOOTER
// C:/Users/bompadre/Documents/angular2/myapp2/font/roboto/Roboto-Thin.ttf
// module id = ../../../../../font/roboto/Roboto-Thin.ttf
// module chunks = styles